import React from "react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";

const DepositForm = () => (
	<div>
		<Field customlabel="Dépôt express disponible" component={Checkbox} name="expressAvailable" id="expressAvailable" required />
		<Field customlabel="Utilisé pour les dépots" component={Checkbox} name="usedForDeposit" id="usedForDeposit" required />
		<Field customlabel="Exige le type de domicile" component={Checkbox} name="requireTypeDomicile" id="requireTypeDomicile" required />

		<Field
			customlabel="Numéro séquentiel non obligatoire pour les dépôts"
			component={Checkbox}
			name="numSeqNotRequiredForDeposit"
			id="numSeqNotRequiredForDeposit"
			required
		/>
		<br />
	</div>
);

export default DepositForm;
